import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
   
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("status");
    sessionStorage.removeItem("setupCompleted");

    setTimeout(() => {
      navigate("/"); 
    }, 1000);
  }, [navigate]);

  return (
    <div className="logout-container">
     
    </div>
  );
};

export default Logout;
